/* eslint no-mixed-operators: 0, spaced-comment: 0, brace-style: 0, indent: 0 */
import getPipeValue from './getPipeValue';
import precise from './precise';

function getLeaseBaseFeeFromWeight(options) {
  const { monthsFromNow, vehicleWeight } = options;

  // Just for debugging purposes.
  // console.log('getLeaseBaseFeeFromWeight called with: ', options);

  const Z = Number(vehicleWeight);
  const W = (Math.round(Z / 100));
  const rset = getPipeValue(options.pipe, `r${monthsFromNow}`);

  let baseFee = 0;

  if (Z !== 0) {
    // calculate total service fees

    // Lease Auto
    if ((rset === 'a15') && (Z !== 0)) {
      // 14 or 15 months
      baseFee = (1.25 * ((17.00) + (1.50 * W)));
    } // 11.60 and 3.30 for double fees over 13 months
    if ((rset === 'a13') && (Z !== 0)) // 13 months
    {
      baseFee = (1.25 * ((17.00) + (1.50 * W)));
    }
    if ((rset === 'a12') && (Z !== 0)) // 7 to 12 months
    {
        baseFee = (((17.00) + (1.50 * W)));
    }
    if ((rset === 'a6') && (Z !== 0)) // 4 to 6 months
    {
        baseFee = (0.50 * ((17.00) + (1.50 * W)));
    }
    if ((rset === 'a3') && (Z !== 0)) // 1 to 3 months
    {
        baseFee = (0.25 * ((17.00) + (1.50 * W)));
    }
    ///////trailer less than 2000
    if ((rset === 't15') && ((Z !== 0) && (Z < 2000))) // 14 or 15 months
    {
        baseFee = (1.25 * ((3.50) + (1.50 * W)));
    }
    if ((rset === 't13') && ((Z !== 0) && (Z < 2000))) // 13 months ??
    {
        baseFee = (1.25 * ((3.50) + (1.50 * W)));
    }
    if ((rset === 't12') && ((Z !== 0) && (Z < 2000))) // 7 to 12 months
    {
        baseFee = (((3.50) + (1.50 * W)));
    }
    if ((rset === 't6') && ((Z !== 0) && (Z < 2000))) // 4 to 6 months
    {
        baseFee = (0.50 * ((3.50) + (1.50 * W)));
    }
    if ((rset === 't3') && ((Z !== 0) && (Z < 2000))) // 1 to 3 months
    {
        baseFee = (0.25 * ((3.50) + (1.50 * W)));
    }

    // Lease Auto ANY 6 month period special
    // special 6 months any
    if ((rset === 'a66') && (Z !== 0)) {
      //$2.50 semi-annual fee plus 11.60 14.10+cbf (partial because some fees are 1/2 for 6 months)
      baseFee = (2.50 + (0.50 * ((17.00) + (1.50 * W))));
      // r12 = 0; // NOTE: what is the point of setting the global r12 to 0?
      // ms = 6; // NOTE: do we need to do this?
    }

    // For Hire Trailers 2000 and over
    if ((rset === 'tp15') && (Z > 1999)) // 14 or 15 months
    {
        baseFee = (1.25 * ((13.50) + (1.50 * W)));
    }
    if ((rset === 'tp13') && (Z > 1999)) // 13 months
    {
        baseFee = (1.25 * ((13.50) + (1.50 * W)));
    }
    if ((rset === 'tp12') && (Z > 1999)) // 7 to 12 months
    {
        baseFee = (((13.50) + (1.50 * W)));
    }
    if ((rset === 'tp6') && (Z > 1999)) // 4 to 6 months
    {
        baseFee = (0.50 * ((13.50) + (1.50 * W)));
    }
    if ((rset === 'tp3') && (Z > 1999)) // 1 to 3 months
    {
        baseFee = (0.25 * ((13.50) + (1.50 * W)));
    }
  }
  return precise(baseFee);
}

export default getLeaseBaseFeeFromWeight;
